import { sqlConnection } from '../../utils/sql'

export const globalToggles = [
  {
    Database: 'CommApp',
    DefaultValue: '40',
    Label: 'Current benchmark:',
    Params: [
      {
        clientID: '9',
      },
    ],
    StoredProcedure: 'sp_Toggle_Econ_Area_BM',
    ParamName: 'BMID',
    Hidden: true,
  },
]

const fetchToggleOptions = async (filters, filterToggles) => {
  const completeToggles = await Promise.all(
    filterToggles.map(
      async ({
        Database,
        Params,
        StoredProcedure,
        ParamName,
        Label,
        DefaultValue,
        Hidden,
      }) => {
        if (!StoredProcedure) {
          throw new Error(
            'A filter toggle should have a stored procedure (check your .ts file sp_toggle)',
          )
        }

        const paramList = (Params || []).reduce((acc, cur) => {
          const defaultParams =
            filters[Object.keys(cur)[0]] || Object.values(cur)[0]
          return [...acc, defaultParams]
        }, [])

        const connectionString = `exec ${Database}.[dbo].${StoredProcedure} ${paramList
          .join(', ')
          .replace(/(, $)/g, '')}`

        const listData = await sqlConnection.raw(connectionString)

        const list = listData.map(({ Label, Value, ParentValue, HasInfo }) => {
          const pValue = ParentValue || null
          const hasInfo = HasInfo || null
          return { Label, Value, ParentValue: pValue, HasInfo: hasInfo }
        })

        /**
         * Sometime it happens that the query string provided has the wrong param value either because
         * the user has changed the client name, or page alias in the URL without removing the query string
         * or because the query string is being ported from page to page.
         * For example monash/population?WebID=20 has no toggle that can provide data with
         * that WebID, therefore we need to check here if the provided param value in the filters matches one of the
         * 'authorised' params in the paramList returned by the stored proc and set the default if it doesn't match.
         */

        if (DefaultValue === null && list.length > 0) {
          DefaultValue = list[0].Value
        }

        const match = list.filter(({ Value }) => Value === filters[ParamName])
        const value = match.length > 0 ? filters[ParamName] : DefaultValue
        const defaultValue: any = list.find(
          ({ Value }) => Value === DefaultValue,
        )
        const activeValue = list.find(({ Value }) => Value === value)

        if (match.length === 0 && !defaultValue && !activeValue) {
          const values = list.map(({ Value }) => Value)
          throw new Error(
            `The active or default value (${value} / ${DefaultValue}) for "${Label}" doesn't match any of the values returned from: ${StoredProcedure} -> (${values})\nCould mean 1 or 2 things:\n- ${DefaultValue} in filterToggles is wrong or\n- ${DefaultValue} is missing from ${StoredProcedure}`,
          )
        }

        return {
          active: activeValue,
          default: defaultValue,
          key: ParamName,
          hidden: Hidden || false,
          list,
          title: Label,
          value,
        }
      },
    ),
  )

  return completeToggles
}

export default fetchToggleOptions
